"use client";

import React, { Fragment } from "react";
import { useState, useContext } from "react";

import { Route, Routes, useLocation } from "react-router-dom";
import CreateOrderForm from "./container/create-order/create-order-form";
import FunctionSetUp from "./container/Function-setup/functionSetup";
//  import ItemXref from "./container/Function-setup/itemXref";
import LogSummary from "./container/log-summary/logSummary";
import Card from "./components/shared-card/card";
// import Dashboard from "./dashboard/page";

import Grid from "@mui/material/Grid";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import SideNav from "./components/side-nav";
import Navbar from "./components/header-nav";
import EdiPurchaseOrders from "./container/Edi-Purchase-Order-Process/ediPurchaseOrder";
import FeatureFlagDataContext from "./store/featureFlags";
// import ShipToXref from "./container/Function-setup/shipToXref";
import User from "./container/user-management/User";
import EntitySearch from "./container/Function-setup/EntitySearch";
import PdfOrder from "./container/pdf-orders/PdfOrder";
import CurrencyConversion from "./container/currency-conversion/currencyConversion";
import ExcelOrder from "./container/excel-orders/ExcelOrder";
import ApiOrder from "./container/api-orders/ApiOrder";
import PhoneOrder from "./container/phone-orders/PhoneOrder";
import Specright from "./container/specright/Specright";
import RegionMapping from "./container/region-mappings/RegionMapping";
import EmailBodyOrder from "./container/email-body-orders/EmailBodyOrder";
import PurchaseOrderInvoice from "./container/purchase-orders-invoice/PurchaseorderInvoice";
import PurchaseOrderCreation from "./container/purchase-orders-creation/PurchaseOrderCreation";
import SalesOrderPicking from "./container/sales-orders-picking/SalesOrderPicking";
import CreditInvoices from "./container/credit-invoices/CreditInvoices";
import DuplicateOrders from "./container/duplicate-orders/DuplicateOrders";
import DuplicateOrdersSummary from "./container/duplicate-orders-summary/DuplicateOrdersSummary";
import SevenElevenOrder from "./container/Seven-Eleven-Orders/SevenElevenOrder";
import OrderConfig from "./container/order-config/OrderConfig";
import ItemAndStoreSearch from "./components/item-or-store-Details/ItemAndStoreDetails";
import KrogerInvoiceConfig from "./container/KrogerInvoiceConfig/KrogerInvoiceConfig";
import OrderRestaging from "./container/order-restaging/OrderRestaging";
import KrogerReportTab from "./container/Kroger-Report/KrogerReportTab";

export default function OfpSegmentsLayout({ children }) {
  const location = useLocation();
  const [isMenuExpanded, setIsMenuExpanded] = useState(true);
  let headingTitle = "";
  const heading = location?.pathname.toLocaleLowerCase();
  // const showAutoLog = JSON.parse(
  //   localStorage.getItem("ApplicationSettings")
  // )?.enableAutoLog;
  const [featureFlags, setFeatureFlags] = useContext(FeatureFlagDataContext);

  const toggleMenu = (toggleFlag) => {
    setIsMenuExpanded(toggleFlag);
  };
  if (heading.includes("create")) {
    headingTitle = "Create Order";
  } else if (heading.includes("function")) {
    headingTitle = "Function Setup";
  } else if (heading.includes("logsummary")) {
    headingTitle = "Manual Order Summary";
  } else if (heading.includes("autolog")) {
    headingTitle = "FTP Orders";
  } else if (heading.includes("website")) {
    headingTitle = "Website Orders";
  } else if (heading.includes("credit-invoices")) {
    headingTitle = "Credit Invoices";
  } else if (heading.includes("edi")) {
    headingTitle = "Switchboard Routing";
  } else if (heading.includes("itemxref")) {
    headingTitle = "ItemXref";
  } else if (heading.includes("itemandstore")) {
    headingTitle = "Item/Store Searching";
  } else if (heading.includes("shiptoxref")) {
    headingTitle = "ShipToXref";
  } else if (heading.includes("users")) {
    headingTitle = "Users Management";
  } else if (heading.includes("entitysearch")) {
    headingTitle = "Entity Search";
  } else if (heading.includes("emailbodyorders")) {
    headingTitle = "Email Body Orders";
  } else if (heading.includes("pdforders")) {
    headingTitle = "PDF Orders";
  } else if (heading.includes("currencyconversion")) {
    headingTitle = "Currency Conversion";
  } else if (heading.includes("excelorders")) {
    headingTitle = "Excel Orders (Coming Soon)";
  } else if (heading.includes("apiorders")) {
    headingTitle = "API Orders (Coming Soon)";
  } else if (heading.includes("phoneorders")) {
    headingTitle = "Phone Orders (Coming Soon)";
  } else if (heading.includes("specright")) {
    headingTitle = "Specright (Coming Soon)";
  } else if (heading.includes("regionmappings")) {
    headingTitle = "Region Mappings";
  } else if (heading.includes("bajaorders")) {
    headingTitle = "Baja Orders";
  } else if (heading.includes("purchaseorderinvoice")) {
    headingTitle = "Purchase Order Invoice";
  } else if (heading.includes("purchaseordercreation")) {
    headingTitle = "Purchase Orders Creation";
  } else if (heading.includes("salesorderspicking")) {
    headingTitle = "Sales Order Picking";
  } else if (heading.includes("credit-invoices")) {
    headingTitle = "Credit Invoice";
  } else if (heading.includes("duplicate-orders-summary")) {
    headingTitle = "Duplicate Orders Summary";
  } else if (heading.includes("duplicate")) {
    headingTitle = "Duplicate Orders";
  } else if (heading.includes("order-flow")) {
    headingTitle = "Staging Configurations";
  }else if (heading.includes("krogerretail")) {
    headingTitle = "Kroger Retail";
  }else if (heading.includes("orderrestaging")) {
    headingTitle = "Order Restaging";
  }else if (heading.includes("kroger-report")) {
    headingTitle = "Kroger Report";
  }
  const getToken = (token) => {
    console.log(token);
  };
  return (
    <Fragment>
    <Grid container className="containerBlock">
      <Grid
        item
        xs={12}
        md={isMenuExpanded ? 2 : 1}
        className="transition menuContainer"
      >
        <SideNav isMenuExpanded={isMenuExpanded} toggleMenu={toggleMenu} />
      </Grid>
      <Grid
        item
        xs={12}
        md={isMenuExpanded ? 10 : 11}
        className="mainContainer transition"
      >
        <Navbar heading={headingTitle} getTokenHandler={getToken} />
        <Card>
          {featureFlags?.enableModernMenu ? (
            <Routes>
              {/* <Route path="dashboard" element={<Dashboard />}></Route> */}
              {/* enableWebSiteOrders */}
              <Route
                path="/orders/website"
                element={<SevenElevenOrder />}
              />
              {/* enableSalesOrdersSummary */}
              <Route
                path="/ordersSummary/duplicate-orders-summary"
                element={<DuplicateOrdersSummary />}
              />
              {/* TODO: 1. wrap feature condition flag : featureFlags?.enableCreditInvoices ex:{featureFlags?.enableSOPick && ()}   */}
              <Route
                path="invoices/credit-invoices"
                element={<CreditInvoices />}
              />
              <Route path="/invoices/kroger-report" element={<KrogerReportTab />} />

              <Route path="invoices" element={<CreditInvoices />} />

              <Route path="orders/create" element={<CreateOrderForm isModernMenuEnabled={true} />} />
              <Route path="orders/" element={<CreateOrderForm isModernMenuEnabled={true} />} />
              <Route
                path="administration/function"
                element={<FunctionSetUp />}
              />
              {/* enableItemOrStoreDetails */}
              {/* {featureFlags?.enableItemOrStoreDetails && ()} */}
              <Route
                path="administration/ItemAndStoreDetails"
                element={<ItemAndStoreSearch />
                }
              />

              {featureFlags?.enableOrderConfig && (<Route path="administration/order-flow" element={<OrderConfig />} />)}
              {/* <Route path="administration/itemXref" element={<ItemXref />} /> */}
              {/* {featureFlags?.enableItemXRef && (
                <Route path="administration/itemXref" element={<ItemXref />} />
              )} */}
              {/* {featureFlags?.enableShipToXref && (
                <Route
                  path="administration/shipToxref"
                  element={<ShipToXref />}
                />
              )} */}
              {featureFlags?.enableEntity && (
                <Route
                  path="administration/entitySearch"
                  element={<EntitySearch />}
                />
              )}
              {featureFlags?.enableOrderActionConfig && (
                <Route path="administration/krogerretail" element={<KrogerInvoiceConfig />} />
              )}
              {featureFlags?.enableUsers && (
                <Route path="UserManagement/Users" element={<User />} />
              )}
              <Route path="/ordersSummary/logsummary" element={<LogSummary />} />
              {featureFlags?.enableAutoLog && (
                <Route path="/orders/autoLog" element={<LogSummary />} />
              )}
              {(featureFlags?.enableSwitchboardWalmartOrders ||
                featureFlags?.enableSwitchboardSamsClubOrders ||
                featureFlags?.enableSwitchboardTraderJoesOrders) && (
                  <Route
                    path="/utilities/ediPurchaseOrder"
                    element={<EdiPurchaseOrders />}
                  />
                )}

              {featureFlags?.enableEmailOrders && (
                <Route
                  path="/orders/emailBodyOrders"
                  element={<EmailBodyOrder />}
                />
              )}
              {featureFlags?.enableOrderRestaging && (
                <Route path="/ordersSummary/orderRestaging" element={<OrderRestaging />} />
              )}
              {featureFlags?.enablePdfOrders && (
                <Route path="/orders/pdfOrders" element={<PdfOrder />} />
              )}

              {featureFlags?.enableCurrencyConversion && (
                <Route
                  path="/utilities/currencyconversion"
                  element={<CurrencyConversion />}
                />
              )}

              {featureFlags?.enableExcelOrders && (
                <Route path="/orders/excelorders" element={<ExcelOrder />} />
              )}

              {featureFlags?.enableApiOrders && (
                <Route path="/orders/apiorders" element={<ApiOrder />} />
              )}

              {featureFlags?.enablePhoneOrders && (
                <Route path="/orders/phoneorders" element={<PhoneOrder />} />
              )}

              {featureFlags?.enableSpecRight && (
                <Route path="/utilities/specright" element={<Specright />} />
              )}

              {(featureFlags?.enableWalmartRegionMappings ||
                featureFlags?.enableSamsClubRegionMappings ||
                featureFlags?.enableTraderJoesRegionMappings) && (
                  <Route
                    path="/utilities/regionMappings"
                    element={<RegionMapping />}
                  />
                )}
              {/* TODO: enable DuplicateOrders flag */}
              <Route
                path="/utilities/duplicate-orders"
                element={<DuplicateOrders />}
              />
              {/* TODO: Remove baja from route*/}
              {/* {featureFlags?.enableBajaOrders && (
                <Route path="/utilities/bajaOrders" element={<BajaOrder />} />
              )} */}

              {featureFlags?.enablePOInvoice && (
                <Route
                  path="/utilities/purchaseOrderInvoice"
                  element={<PurchaseOrderInvoice />}
                />
              )}

              {featureFlags?.enablePOCreate && (
                <Route
                  path="/utilities/purchaseOrderCreation"
                  element={<PurchaseOrderCreation />}
                />
              )}

              {featureFlags?.enableSOPick && (
                <Route
                  path="/utilities/salesOrdersPicking"
                  element={<SalesOrderPicking />}
                />
              )}

              {/* <Route path="/" element={<h1>{ <CreateOrderForm />}</h1>} /> */}
              <Route
                path="*"
                element={<h1>{"404 This page could not be found."}</h1>}
              />
            </Routes>
          ) : (
            <Routes>
              {/* <Route path="dashboard" element={<Dashboard />}></Route> */}
              {/* enableWebSiteOrders */}
              <Route
                path="/orders/webSite"
                element={<SevenElevenOrder />}
              />
              {/* TODO: 1. wrap feature condition flag : featureFlags?.enableCreditInvoices  ex:{featureFlags?.enableSOPick && ()}  */}
              <Route
                path="invoices/credit-invoices"
                element={<CreditInvoices />}
              />
              <Route path="invoices/credit-invoices" element={<CreditInvoices />} />

              <Route path="orders/create" element={<CreateOrderForm isModernMenuEnabled={false} />} />
              <Route path="orders/" element={<CreateOrderForm isModernMenuEnabled={false} />} />
              <Route
                path="administration/function"
                element={<FunctionSetUp />}
              />
              {/* enableItemOrStoreDetails */}
              {/* {featureFlags?.enableItemOrStoreDetails && (

              )} */}
              <Route
                path="administration/ItemAndStoreDetails"
                element={<ItemAndStoreSearch />}
              />
              {featureFlags?.enableOrderRestaging && (
                <Route path="/ordersSummary/orderRestaging" element={<OrderRestaging />} />
              )}
              {featureFlags?.enableOrderConfig && (<Route path="administration/order-flow" element={<OrderConfig />} />)}
              {/* <Route path="administration/itemXref" element={<ItemXref />} /> */}
              {/* {featureFlags?.enableItemXRef && (
                <Route path="administration/itemXref" element={<ItemXref />} />
              )}
              {featureFlags?.enableShipToXref && (
                <Route
                  path="administration/shipToxref"
                  element={<ShipToXref />}
                />
              )} */}
              {featureFlags?.enableEntity && (
                <Route
                  path="administration/entitySearch"
                  element={<EntitySearch />}
                />
              )}
              {featureFlags?.enableUsers && (
                <Route path="UserManagement/Users" element={<User />} />
              )}
              <Route path="/orders/logsummary" element={<LogSummary />} />
              {featureFlags?.enableAutoLog && (
                <Route path="/orders/autoLog" element={<LogSummary />} />
              )}

              {(featureFlags?.enableSwitchboardWalmartOrders ||
                featureFlags?.enableSwitchboardSamsClubOrders ||
                featureFlags?.enableSwitchboardTraderJoesOrders) && (
                  <Route
                    path="/orders/ediPurchaseOrder"
                    element={<EdiPurchaseOrders />}
                  />
                )}

              {(featureFlags?.enableWalmartRegionMappings ||
                featureFlags?.enableSamsClubRegionMappings ||
                featureFlags?.enableTraderJoesRegionMappings) && (
                  <Route
                    path="/administration/regionMappings"
                    element={<RegionMapping />}
                  />
                )}

              {/* TODO: enable DuplicateOrders flag */}
              {/* EX: {featureFlags?.enableBajaOrders && (
                <Route path="/orders/bajaOrders" element={<BajaOrder />} />
              )} */}
              <Route
                path="/orders/duplicate-orders"
                element={<DuplicateOrders />}
              />
              {/* enableSalesOrdersSummary */}
              <Route
                path="/orders/duplicate-orders-summary"
                element={<DuplicateOrdersSummary />}
              />

              {featureFlags?.enableEmailOrders && (
                <Route
                  path="/orders/emailBodyOrders"
                  element={<EmailBodyOrder />}
                />
              )}

              {featureFlags?.enablePdfOrders && (
                <Route path="/orders/pdfOrders" element={<PdfOrder />} />
              )}

              {featureFlags?.enableCurrencyConversion && (
                <Route
                  path="/administration/currencyconversion"
                  element={<CurrencyConversion />}
                />
              )}

              {featureFlags?.enableExcelOrders && (
                <Route path="/orders/excelorders" element={<ExcelOrder />} />
              )}

              {featureFlags?.enableApiOrders && (
                <Route path="/orders/apiorders" element={<ApiOrder />} />
              )}

              {featureFlags?.enablePhoneOrders && (
                <Route path="/orders/phoneorders" element={<PhoneOrder />} />
              )}

              {featureFlags?.enableSpecRight && (
                <Route path="/orders/specright" element={<Specright />} />
              )}

              {featureFlags?.enablePOInvoice && (
                <Route
                  path="/orders/purchaseOrderInvoice"
                  element={<PurchaseOrderInvoice />}
                />
              )}

              {featureFlags?.enablePOCreate && (
                <Route
                  path="/orders/purchaseOrderCreation"
                  element={<PurchaseOrderCreation />}
                />
              )}

              {featureFlags?.enableSOPick && (
                <Route
                  path="/orders/salesOrdersPicking"
                  element={<SalesOrderPicking />}
                />
              )}

              {/* <Route path="/" element={<h1>{ <CreateOrderForm />}</h1>} /> */}
              <Route
                path="*"
                element={<h1>{"404 This page could not be found."}</h1>}
              />
            </Routes>
          )}
        </Card>
      </Grid>
      
    </Grid>
     <Grid container className="containerBlock">
      <Grid
        item
        xs={12}
        md={isMenuExpanded ? 2 : 1}
        className="transition menuContainer"
      ></Grid>
           <Grid
        item
        xs={12}
        md={isMenuExpanded ? 10 : 11}
        className="mainContainer transition"
      >
          <div style={{ paddingTop: "30px" }}>
        <div className="grid">
          <div className="col-12">
            <hr
              style={{
                height: "0.5px",
                borderWidth: "0",
                color: "gray",
                backgroundColor: "#d6d6d6"
              }}
            ></hr>
            <div className="md:flex md:justify-content-between">
              <p
                style={{
                  color:
                    "var(--Light-Text-Default-Text, var(--BlueGray-BlueGray-700, #334155))",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "20px"
                }}
              >
                Copyright &#169; 2024 Taylor Farms. All rights reserved.
              </p>
              <p className="sm:text-center font-normal line-height-3 text-center text-sm"
                style={{
                  color:
                    "var(--Light-Text-Default-Text, var(--BlueGray-BlueGray-700, #ffc107))",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                }}
              >
                Version: 2.0
              </p>
            </div>
          </div>

        </div>


      </div>
      </Grid>
      
      </Grid>
  
    </Fragment>
    //   <div className="grid containerBlock">
    //   <div
    //   className={`col-12 ${isMenuExpanded ? 'lg:col-3' : 'lg:col-1'} transition menuContainer`}
    //   >
    //     <SideNav isMenuExpanded={isMenuExpanded} toggleMenu={toggleMenu} />
    //   </div>
    //   <div
    //   className={`col-12 ${isMenuExpanded ? 'lg:col-9' : 'lg:col-11'} mainContainer transition`}
    //   >
    //     <Navbar />
    //     <Card>
    //       <Routes>
    //         <Route path="dashboard" element={<Dashboard />}></Route>
    //         <Route path="orders/create-order" element={<CreateOrderForm />} />
    //         <Route path="orders/" element={<CreateOrderForm />} />

    //         <Route path="/" element={<h1>{ '404 This page could not be found.' }</h1>} />
    //         <Route path="*" element={<h1>{ '404 This page could not be found.' }</h1>} />
    //       </Routes>
    //     </Card>
    //   </div>
    // </div>
  );
}
